import {Badge as MantineBadge} from '@mantine/core';

/**
 * Small status/count badge — design-layer pass-through over Mantine `Badge`.
 * @registry Pass-through Mantine Badge; import this instead of @mantine/core outside src/design.
 */
export const Badge = MantineBadge;
